import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";

import { Modal, Button } from "semantic-ui-react";

function ModalPayPal(props) {
    const [paid, setPaid] = useState(false);
    const [error, setError] = useState(null);
    const paypalRef = useRef();

    // sb-dr43k83939740@personal.example.com
    // KA8hR@,O

    useEffect(() => {
        window.paypal
            .Buttons({
                createOrder: (data, actions) => {
                    return actions.order.create({
                        intent: "CAPTURE",
                        purchase_units: [
                            {
                                description: "Your description",
                                amount: {
                                    currency_code: "EUR",
                                    value: props.price,
                                },
                            },
                        ],
                    });
                },
                onApprove: async (data, actions) => {
                    setPaid(true);
                },
                onError: (err) => {
                    setError(err)
                },
            })
            .render(paypalRef.current);
    });

    function handleChangeModal() {
        props.onChange(false);
    }

    if (paid) {
        toast.success((props.lang === "es") ? 'Pago exitoso!' : 'Payment successful!', {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        handleChangeModal();
    }

    if (error) {
        toast.error((props.lang === "es") ? 'Ocurrió un error al procesar el pago! Inténtalo de nuevo.' : 'Error Occurred in processing payment! Please try again.', {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }


    return (
        <div>
            <Modal
                size="tiny"
                open={true}
                onClose={handleChangeModal}
                className="modal-paypal"
            >
                <Modal.Header>Payment with paypal</Modal.Header>
                <Modal.Content>
                    <div ref={paypalRef} />
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="Close"
                        labelPosition='right'
                        icon='close'
                        onClick={handleChangeModal}
                        negative
                    />
                </Modal.Actions>
            </Modal>
        </div>
    );
}

export default ModalPayPal;